/**
 * Google Analytics / Google Ads events (GA4 recommended names), so ads can
 * optimise for real outcomes: sign_up, add_to_cart, begin_checkout, purchase.
 * Does nothing when the tag is not loaded (crawlers, staff — see
 * framework.blade.php) or blocked.
 */
type Gtag = (command: 'event', name: string, params?: Record<string, unknown>) => void;

export function track(event: string, params: Record<string, unknown> = {}) {
  try {
    const gtag = (window as unknown as {gtag?: Gtag}).gtag;
    gtag?.('event', event, params);
  } catch {
    // analytics must never break the page
  }
}

/** Once per key in this browser (a purchase must not count twice on reload). */
export function trackOnce(key: string, event: string, params: Record<string, unknown> = {}) {
  const storageKey = `mtk.tracked.${key}`;
  try {
    if (localStorage.getItem(storageKey)) return;
    localStorage.setItem(storageKey, '1');
  } catch {
    // storage blocked: send it anyway
  }
  track(event, params);
}

/** Cents → dollars for GA's `value`. */
export const toValue = (cents: number | null | undefined) => Math.round(Number(cents || 0)) / 100;
